import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
	menulist: {
		padding: '8px',
		'& > *': {
			borderRadius: 1,
		},
	},
	paperClass: {
		width: '150px',
	},
	typography: {
		display: 'flex',
		alignItems: 'center',
	},
}));

export default styles;
